import { Typography, Divider, Chip } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

import { Link } from "react-router-dom";

import "./project.css";

//photo
import photo from "../../assetes/main Project.png";

const Project = () => {
  return (
    <>
      <Grid container>
        <div id="projects" style={{ paddingTop: "60px", paddingLeft: "rem" }}>
          <Grid>
            <Divider
              textAlign="center"
              sx={{
                mt: 5,
                "&::before,&::after": {
                  borderColor: "primary",
                },
              }}
            >
              <Chip
                sx={{ p: 3 }}
                label={
                  <Typography variant="h2" sx={{ fontSize: "2rem", margin: 2 }}>
                    پروژه های ایما
                  </Typography>
                }
              ></Chip>
            </Divider>
          </Grid>
          <Typography sx={{ m: 4, textAlign: "center", fontSize: "1.2rem" }}>
            این واحد با اتکا به تجربیات چندین ساله مدیران و کارشناسان فنی خود ،
            کار مشاوره ، طراحی و اجرای پروژه های صنعتی مختلف را بر عهده داشته و
            تاکنون موفق به اجرای بیش از صد پروژه صنعتی گردیده است .
          </Typography>
          <Grid container>
            <Grid xs={12}>
              <Link
                to="/imaProjects"
                component="Button"
                className="link-project"
                style={{ textAlign: "center" }}
              >
                لیست پروژه ها
              </Link>
            </Grid>

            <Grid xs={12}>
              <img
                src={photo}
                alt="پروژه های ایما"
                className="img-project"
              ></img>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </>
  );
};

export default Project;
